export default "__VITE_ASSET__BLWaa0IE__"